<div class="smooth-scrolling">
    <div *ngIf="!userId" class="offer-lebal-slider" (click)="profileClick(true)">
        <owl-carousel-o [options]="offerlebalSlider">
            <ng-template carouselSlide>
                <div class="offer-lebal">
                    <span>
                        {{home_first_text}}
                    </span>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="offer-lebal">
                    <span>
                        {{home_first_text}}
                    </span>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
    <!-- offer lebal text end  -->

    <!-- banner section start  -->

    <section class="home-banner-slider">
        <div class="row">
            <div class="col-lg-12">
                <div class="home-banner">
                    <owl-carousel-o class="banner-slider" [options]="homeSlider">
                        <ng-template carouselSlide *ngFor="let imagePreview_home of imagePreview_banner; let i = index">
                            <div class="home-banner-img d-sm-flex d-none">
                                <img appPreLoading [src]="imagePreview_home" alt="img">
                            </div>
                            <div class="home-banner-img d-sm-none d-flex">
                                <img appPreLoading [src]="imagePreview_home" alt="img">
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </section>

    <!-- banner section start  -->

    <!-- beauty solutions text section start   -->
    <section class="skincare-section">
        <div class="mx-825">
            <h4><b>Beauty Solutions</b> made simple just <b>for you</b></h4>
        </div>
        <div class="skin-scroll scrollbar">
            <ul class="new-coming-btn">
                <li class="btn-purple coming" [class.show-coming]="hoveredBtn === 'btn-purple'">
                    <div class="coming-soon">
                        Coming <br> Soon
                    </div>
                </li>
                <li class="btn-pink coming" [class.show-coming]="hoveredBtn === 'btn-pink'">
                    <div class="coming-soon coming-bg-2">
                        Coming <br> Soon
                    </div>
                </li>
                <li class="btn-orange coming" [class.show-coming]="hoveredBtn === 'btn-orange'">
                    <div class="coming-soon coming-bg-3">
                        Coming <br> Soon
                    </div>
                </li>
            </ul>

            <ul class="mt-0">
                <li class="btn-purple" (mouseover)="setHoveredBtn('btn-purple')" (mouseout)="resetHoveredBtn()">
                    <span>
                        <a class="btn-1">skin quiz</a>
                    </span>
                </li>
                <li class="btn-pink" (mouseover)="setHoveredBtn('btn-pink')" (mouseout)="resetHoveredBtn()">
                    <span>
                        <a class="btn-1">consultation</a>
                    </span>
                </li>
                <li class="btn-orange" (mouseover)="setHoveredBtn('btn-orange')" (mouseout)="resetHoveredBtn()">
                    <span>
                        <a class="btn-1">hair test</a>
                    </span>
                </li>
            </ul>

        </div>
    </section>
    <!-- beauty solutions text section end  -->


    <!-- store section start  -->
    <section class="store-section">
        <div class="store-title text-center">
            <h4><i>What’s in</i> <b>store</b> <i>FOR YOU ?</i></h4>
        </div>
        <div class="skin-care-type-slide scrollbar">
            <ul>
                <li *ngFor="let category of categoryList;let i = index" (click)="getSubCategory(category)">
                    <a
                        [ngClass]="(category.id == selectedCategoryId) && (category?.id == 1) ? 'active' : (category.id == selectedCategoryId) && (category?.id == 2) ? 'active-makeup' : (category.id == selectedCategoryId) && (category?.id != 1 && category?.id != 2) ? 'active-rest' : ''">{{category?.name}}</a>
                    <span class="back-gradient-shadow"
                        [ngStyle]="category.id == selectedCategoryId ? { 'background': categoryColor } : {} "></span>
                </li>
            </ul>
        </div>
        <div class="store-slider scrollbar">
            <div class="store-img-detail" *ngFor="let subCategory of subCategoryList; let i = index;">
                <a (click)="goToShopAll(catName,subCategory.category_id , subCategory.id)">
                    <div class="store-img">
                        <img appPreLoading
                            [lazyLoad]="subCategory && subCategory.imageList.length > 0 && subCategory.imageList[0].path && subCategory.imageList[0].path ? subCategory.imageList[0].path : 'assets/images/no-image-png.png'"
                            (error)="handleImageError($event)" alt="img">
                    </div>
                    <span>{{subCategory?.name}}</span>
                </a>
            </div>
        </div>
    </section>
    <!-- store section start  -->
    <!-- troybling section start  -->
    <section class="troybling-section" *ngIf="skinConcernList && skinConcernList.length > 0">
        <div class="store-title text-center">
            <h4><i>What’s</i> <b>troubling</b> <i>YOU ?</i></h4>
        </div>
        <div class="troubling-new">
            <div class="troubling-size" *ngFor="let skinConcern of skinConcernList; let i = index">
                <div class="troubling-acne">
                    <div class="troubling-detail-acne"
                        (click)="goToShopAllWithSkinConcern(skinConcern.category,skinConcern.category_id , skinConcern.id)">
                        <img appPreLoading
                            [lazyLoad]="skinConcern && skinConcern.imageList.length > 0 && skinConcern.imageList[0].path && skinConcern.imageList[0].path ? skinConcern.imageList[0].path : 'assets/images/no-image-png.png'"
                            (error)="handleImageError($event)" alt="img">
                    </div>
                    <span
                        (click)="goToShopAllWithSkinConcern(skinConcern.category,skinConcern.category_id , skinConcern.id)">{{skinConcern?.name}}</span>
                </div>
            </div>
        </div>

        <div class="offer-section-new-heading">
            <div class="store-title text-center">
                <h4><b>FEATURED</b> <i>COLLECTION</i></h4>
            </div>
            <div class="new-offer-section" *ngIf="allUnderDiscountCatelogue && allUnderDiscountCatelogue.length > 0">
                <div class="offer-size" *ngFor="let discount of allUnderDiscountCatelogue; let i  = index">
                        <div class="offer-section-new shadow-one">
                            <button class="offer-button p-0" (click)="redirectToShopAll(discount.url)">
                                <div class="offer-section-img-new">
                                    <img appPreLoading
                                        [lazyLoad]="discount && discount.image_url1 && discount.image_url1.indexOf('https') == -1 ? showImage(discount.image_url1) : discount.image_url1.indexOf('https') != -1 ? discount.image_url1 : 'assets/images/home-offer-1.png'"
                                        alt="image">
                                </div>
                                <div class="offer-section-new-text">
                                    <div class="offer-heading">
                                    </div>
                                </div>
                            </button>
                        </div>
                </div>
            </div>
        </div>
    </section>

    <!-- troybling section start  -->
    <!-- FOY Favourites section start  -->
    <section class="foy-favorites-section scrollbar" *ngIf="tagsProducts && tagsProducts.length > 0">
        <div class="foy-favorites-text">
            <span>FOY <small>Favourites</small></span>
        </div>
        <div class="arrow-btn">
            <div class="makeup-section-detail white-space-remove" id="favProduct" #favProduct>
                <a class="left-arrow-btn" *ngIf="showFavLeftArrow"><img (click)="goLeft('favProduct')"
                        src="assets/images/left-arrow.png" alt=""></a>
                <div class="col-xl-3 col-lg-4 col-md-4 col-6 px-lg-2 px-1"
                    *ngFor="let product of tagsProducts; let i  = index">
                    <app-product-box (onUserLogin)="getUserId()" [color]="product.category ? product.category.color : ''" [product]="product"
                        [mAddUpdateCartModule]="mAddUpdateCartModule"
                        [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                        [mWishlistData]="mWishlistData"></app-product-box>
                </div>
                <a class="right-arrow-btn" *ngIf="showFavRightArrow"><img (click)="goRight('favProduct')"
                        src="assets/images/right-arrow.png" alt=""></a>
            </div>
        </div>
    </section>

    <!-- FOY Favourites section start  -->
    <!-- Brands for you section start  -->
    <section class="brands-section"
        *ngIf="mGetBrandResponse && mGetBrandResponse.data && mGetBrandResponse?.data.length > 0">
        <div class="row">
            <div class="col-12">
                <div class="store-title text-center">
                    <h4><b>Brands</b> <i>for you </i></h4>
                </div>
                <div class="brands-section-detail scrollbar">
                    <div class="brands-img">
                        <a *ngFor="let brand of firstBrandList; let i = index;"><img (click)="viewBrandDetail(brand)"
                                [src]="brand && brand.logo_image  ?  brand.logo_image : 'assets/images/no-image-png.png'"
                                (error)="handleImageError($event)" alt="img"></a>
                    </div>
                </div>
                <div class="brands-section-detail scrollbar">
                    <div class="brands-img">
                        <a *ngFor="let brand of secondBrandList; let i = index;"><img (click)="viewBrandDetail(brand)"
                                [src]="brand && brand.logo_image  ?  brand.logo_image : 'assets/images/no-image-png.png'"
                                (error)="handleImageError($event)" alt="img"></a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Brands for you section start  -->
    <!-- offer section start  -->
    <section class="offer-section" *ngIf="offersDiscountCatelogue && offersDiscountCatelogue.length > 0">
        <div class="row">
            <div class="col-12">
                <div class="store-title text-center d-lg-block d-none">
                    <h4><b>offers</b> <i>for you </i></h4>
                </div>
                <div class="store-title text-center d-lg-none d-block">
                    <h4><b>offers</b></h4>
                </div>
            </div>
            <div class="col-md-3 col-6 mb-2" *ngFor="let offers of offersDiscountCatelogue; let i = index;">
                <a (click)="redirectToShopAll(offers.url)">
                    <div class="offer-detail-img">
                        <img [src]="offers && offers.image_url1 && offers.image_url1.indexOf('https') == -1 ? showImage(offers?.image_url1) : offers.image_url1.indexOf('https') != -1 ? offers.image_url1 : 'assets/images/home-offer-1.png'"
                            alt="img">
                    </div>
                </a>
            </div>
        </div>
    </section>
    <!-- offer section start  -->
    <!-- makeup on the go section start  -->

    <section class="foy-favorites-section makeup-bg scrollbar" *ngIf="makupProducts && makupProducts.length > 0">
        <div class="row">
            <div class="col-12">
                <div class="foy-favorites-text">
                    <span>make up <small>on the go</small></span>
                </div>
                <div class="arrow-btn">
                    <div class="makeup-section-detail white-space-remove" id="makeupProduct" #makeupProduct>
                        <a class="left-arrow-btn" *ngIf="showMakeupLeftArrow"><img (click)="goLeft('makeupProduct')"
                                src="assets/images/left-arrow.png" alt=""></a>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-6 px-lg-2 px-1"
                            *ngFor="let product of makupProducts; let i  = index">
                            <app-product-box (onUserLogin)="getUserId()" [color]="product.category ? product.category.color : ''"
                                [product]="product" [mAddUpdateCartModule]="mAddUpdateCartModule"
                                [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                                [mWishlistData]="mWishlistData"></app-product-box>
                        </div>
                        <a class="right-arrow-btn" *ngIf="showMakeupRightArrow"><img (click)="goRight('makeupProduct')"
                                src="assets/images/right-arrow.png" alt=""></a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- makeup on the go section start  -->
    <!-- shop by skin type section start   -->
    <section class="shop-skin" *ngIf="skinTypeList && skinTypeList.length > 0">
        <div class="row">
            <div class="col-12">
                <div class="store-title text-center">
                    <h4><i>shop By</i> <b>skin type</b></h4>
                </div>
            </div>
            <div class="shop-skin-slider scrollbar">
                <div class="shop-skin-slider-detail" *ngFor="let skinType of skinTypeList; let i = index"
                    (click)="goToShopAllWithSkinType(skinType.category,skinType.category_id , skinType.id)">
                    <div class="shop-skin-slider-detail-img">
                        <img appPreLoading
                            [lazyLoad]="skinType && skinType.imageList.length > 0 && skinType.imageList[0].path && skinType.imageList[0].path ? skinType.imageList[0].path : 'assets/images/no-image-png.png'"
                            (error)="handleImageError($event)" alt="img">
                    </div>
                    <span
                        (click)="goToShopAllWithSkinType(skinType.category,skinType.category_id , skinType.id)">{{skinType?.name}}</span>
                </div>
            </div>
        </div>
    </section>
    <!-- shop by skin type section End   -->

    <!-- whats trending section start  -->
    <section class="what-trending" *ngIf="trendingBlogs && trendingBlogs.length > 0">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="heading heading-two ">
                    <h4><i>Trending</i> <b>blogs</b></h4>
                </div>
                <div class="trending-d arrow-btn" >
                    <a class="left-arrow-btn" *ngIf="showTrendinLeftArrow"><img (click)="goLeft('trendingblog')"
                            src="/assets/images/left-arrow.png" alt=""></a>
                    <div class="row trending-d-scroll scrollbar-width-none" id="trendingblog" #trendingblog>
                        <div class="col-lg-4 col-sm-6 col-12" *ngFor="let trendingBlog of trendingBlogs; let i = index">
                            <app-blogs [categoryList]="mCategoryResponseModal?.data" [blog]="trendingBlog"></app-blogs>
                        </div>
                    </div>
                    <a class="right-arrow-btn" *ngIf="showTrendinRightArrow"><img (click)="goRight('trendingblog')"
                            src="/assets/images/right-arrow.png" alt=""></a>
                </div>
                <button class="view-all-btn-foy black-c" (click)="showAllTrending()">view all</button>
            </div>

        </div>
    </section>

    <!-- whats trending section start  -->

    <section class="authentic-section" *ngIf="website_configuration && website_configuration.length > 0">
        <div class="row">
            <div class="col-lg-3 col-6 my-2" *ngFor="let wpc of website_configuration;let i = index;">
                <div class="authentic">
                    <div class="authentic-img">
                        <img [src]="wpc.image" alt="img">
                    </div>
                    <span>{{wpc.value}}</span>
                </div>
            </div>
        </div>
    </section>
</div>

<app-footer-bg></app-footer-bg>